
import Notification from '@/components/helper/Notification.vue'
import IconCloseFilled from '@svg/IconCloseFilled.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

type UseCaseOption = {
  text: string
  value: string
}

@Component({
  components: {
    IconCloseFilled,
    Notification,
  },
})
export default class GenerateJigFormSection extends Vue {
  private readonly minDescriptionLength: number = 10
  private readonly maxDescriptionLength: number = 2000

  @Prop({ type: Boolean, default: false })
  public isGlobalAIOptOut!: boolean

  @Prop({ type: String, default: '' })
  public errorMessage!: string

  @Prop({ type: Boolean, default: false })
  public showCompletionUnknownWarning!: boolean

  private jigDescription: string = ''
  private jigName: string = ''
  private jigUseCase: string | null = ''
  private isFormValid: boolean = false

  private get useCaseOptions(): UseCaseOption[] {
    return [
      { text: 'Annotated diagram', value: 'tol-jig-annotated-diagram' },
      { text: 'Instructional guide', value: 'tol-jig-instructional-guide' },
      { text: 'Teaching module', value: 'tol-jig-teaching-module' },
      { text: 'Technical sales presentation', value: 'tol-jig-technical-sales-presentation' },
      { text: 'Trade show demo', value: 'tol-jig-trade-show-demo' },
    ]
  }

  private descriptionRules: Array<(v: string) => boolean | string> = [
    (v: string) => !!v || 'Description is required',
    (v: string) => (v && v.trim().length >= this.minDescriptionLength) || 'Description must be at least 10 characters',
    (v: string) => (!v || v.length <= this.maxDescriptionLength) || `Description must be ${this.maxDescriptionLength} characters or fewer`,
  ]

  private useCaseRules: Array<(v: string | null) => boolean | string> = [
    (v: string | null) => !!v || 'Use case is required',
  ]

  private get isGenerateEnabled(): boolean {
    const trimmedDescription = this.jigDescription ? this.jigDescription.trim() : ''
    const hasSelectedUseCase = this.getNormalizedUseCaseValue().length > 0
    return !this.isGlobalAIOptOut &&
      this.isFormValid &&
      hasSelectedUseCase &&
      trimmedDescription.length >= this.minDescriptionLength &&
      trimmedDescription.length <= this.maxDescriptionLength
  }

  private getNormalizedUseCaseValue(): string {
    return this.jigUseCase ? this.jigUseCase.trim() : ''
  }

  private getSelectedUseCaseLabel(): string {
    const selectedUseCase = this.getNormalizedUseCaseValue()
    const selected = this.useCaseOptions.find((option: UseCaseOption) => option.value === selectedUseCase)
    return selected ? selected.text : ''
  }

  private emitGenerate() {
    if (!this.isGenerateEnabled) {
      return
    }

    this.$emit('generate', {
      description: this.jigDescription,
      name: this.jigName,
      useCase: this.getNormalizedUseCaseValue(),
      useCaseLabel: this.getSelectedUseCaseLabel(),
    })
  }
}
